import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Input, Button, Grid, Header, Divider } from 'semantic-ui-react';
import _ from 'lodash';

// Components
import { BtnWithActions } from 'components/Buttons';
import AnagraficaForm from 'components/Forms/Anagrafica';
import { mapToInitialValues, initialValues } from 'components/Forms/Anagrafica/Base/initialValues';
import { mapToClienteInitialValues, clienteInitialValues } from 'components/Forms/Anagrafica/Cliente/initialValues';
import FullModal from 'components/Modal';

// Constants
import { ACL } from 'shared/constants';

// Services
import AclService from '../../../shared/lib/acl';
import AnagraficaService from '../../../shared/services/api/anagrafica';
import ProvenienzaService from '../../../shared/services/api/provenienza';
import GestioneCollaboratoreService from '../../../shared/services/rpc/gestione-collaboratore';
import GestioneProcessoImprese from '../../../shared/services/rpc/gestione-processo-imprese';

class ImpresaGarante extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      isLoading: false,
      searchedAnagrafica: null,

      isSelectCollaboratoreOpen: false,
      selectedCollaboratore: this.props.auth.collaboratoreId,

      modalAnagraficaOpened: false,
      selectedAnagrafica: {},
      provenienzeOptions: null,
      isLoadingAnagrafica: false,
    };
  }

  componentDidMount() {
    // Load provenienza options for the anagrafica form
    ProvenienzaService.getOptions()
      .then((provenienzeOptions) => {
        this.setState({ provenienzeOptions });
      })
      .catch(() => {
        // Silently fail - provenienza options are optional
      });
  }

  onAggiungiGarante = () => {
    GestioneProcessoImprese.aggiungiGarante(this.props.impresa.id, this.state.searchedAnagrafica.id)
      .then(() => {
        this.props.notification().addNotification({
          message: 'Garante aggiunto con successo',
          level: 'success',
        });
        // Refresh impresa data if needed
        if (this.props.onRefresh) {
          this.props.onRefresh();
        }
      })
      .catch(() => {
        this.props.notification().addNotification({
          message: 'Impossibile aggiungere il garante',
          level: 'error',
        });
      });
  };

  onRemoveGarante = () => {
    GestioneProcessoImprese.rimuoviGarante(this.props.impresa.id)
      .then(() => {
        this.props.notification().addNotification({
          message: 'Garante rimosso con successo',
          level: 'success',
        });
        // Refresh impresa data if needed
        if (this.props.onRefresh) {
          this.props.onRefresh();
        }
      })
      .catch(() => {
        this.props.notification().addNotification({
          message: 'Impossibile rimuovere il garante',
          level: 'error',
        });
      });
  };

  onSelectCollaboratore = () => {
    if (!this.props.auth.agenzie.current) {
      this.props.notification().addNotification({
        message: "Prima di procedere con la creazione selezionare un'agenzia nella topBar",
        level: 'warning',
      });

      return;
    }

    if (_.isEmpty(this.state.selectedCollaboratore)) {
      this.props.notification().addNotification({
        message: 'Selezionare un collaboratore',
        level: 'warning',
      });

      return;
    }

    this.onCloseSelectCollaboratore();
    this.props.createImpresa(
      this.state.searchedAnagrafica.id,
      this.props.auth.agenzie.current,
      this.state.selectedCollaboratore
    );
  };

  onCloseSelectCollaboratore = () => this.setState({ isSelectCollaboratoreOpen: false });

  handleSearchClick = () => {
    if (_.isEmpty(this.state.searchText) || this.state.searchText.length <= 9) {
      this.props.notification().addNotification({
        message: 'Inserire un codice fiscale valido',
        level: 'warning',
      });

      return;
    }

    this.setState({ isLoading: true });
    AnagraficaService.getByPIVAorCF(this.state.searchText)
      .then((res) => {
        const anagrafica = _.get(res, '_embedded.anagrafica[0]');
        if (_.isEmpty(anagrafica)) {
          this.props.notification().addNotification({
            message: 'Anagrafica non trovata',
            level: 'warning',
          });
        } else {
          this.setState({ searchedAnagrafica: anagrafica });
        }
      })
      .catch(() => {
        this.props.notification().addNotification({
          message: "Impossibile recuperare l'anagrafica",
          level: 'error',
        });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  /** Load collaboratori */
  loadCollaboratori = () =>
    GestioneCollaboratoreService.getCollaboratoreByTipoOption(
      null,
      null,
      _.get(this.props.auth.agenzie, 'current') ? [_.get(this.props.auth.agenzie, 'current')] : [],
      null,
      null,
      true
    );

  onOpenModalAnagrafica = () => {
    const { impresa } = this.props;

    if (!impresa || !impresa.garante || !impresa.garante.id) {
      return;
    }

    this.setState({ isLoadingAnagrafica: true, modalAnagraficaOpened: true });

    // Fetch the full anagrafica data
    AnagraficaService.get(impresa.garante.id)
      .then((anagrafica) => {
        this.setState({
          selectedAnagrafica: anagrafica,
          isLoadingAnagrafica: false,
        });
      })
      .catch(() => {
        this.props.notification().addNotification({
          message: "Impossibile caricare i dati dell'anagrafica",
          level: 'error',
        });
        this.setState({
          modalAnagraficaOpened: false,
          isLoadingAnagrafica: false,
        });
      });
  };

  onCloseModalAnagrafica = () => {
    this.setState({
      modalAnagraficaOpened: false,
      selectedAnagrafica: {},
    });

    // Refresh impresa data if needed
    if (this.props.onRefresh) {
      this.props.onRefresh();
    }
  };

  getActions = () =>
    [
      this.props.impresa &&
        this.props.impresa.garante &&
        this.props.impresa.garante.id && {
          icon: 'edit',
          label: 'Modifica anagrafica',
          action: () => this.onOpenModalAnagrafica(),
        },
      this.props.impresa &&
        this.props.impresa.garante &&
        this.props.impresa.garante.id &&
        this.props.impresa.stato === 'aperta' && {
          icon: 'delete',
          label: 'Rimuovi garante',
          action: () => this.onRemoveGarante(),
        },
    ].filter(Boolean);

  handleInputChange(text) {
    this.setState({ searchText: text });
  }

  render() {
    const { isGarantePresente, isCreatingImpresa, impresa, notification } = this.props;
    const { searchedAnagrafica, modalAnagraficaOpened, selectedAnagrafica, provenienzeOptions, isLoadingAnagrafica } =
      this.state;

    if (!isGarantePresente) {
      return (
        <div style={{ padding: '10px', marginBottom: '10px' }}>
          <Header>
            <Divider horizontal>GARANTE</Divider>
            {isGarantePresente ? (
              <Header.Subheader>
                Inserire il codice fiscale del soggetto che si vuole aggiungere come garante
              </Header.Subheader>
            ) : null}
          </Header>
          <Grid>
            <Grid.Column width={10}>
              <Input
                fluid
                mandatory
                disabled={this.state.isLoading}
                loading={this.state.isLoading}
                placeholder="Inserisci il codice fiscale o p.iva del garante"
                value={this.state.searchText}
                onChange={(_e, data) => this.handleInputChange(data.value)}
              />
            </Grid.Column>
            <Grid.Column width={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
              <Button
                labelPosition="right"
                disabled={this.state.isLoading}
                primary
                icon="search"
                onClick={this.handleSearchClick}
                content="Cerca anagrafica"
              />
            </Grid.Column>
          </Grid>
          {!_.isEmpty(searchedAnagrafica) ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div
                style={{
                  marginTop: '8px',
                  border: '1px solid #d4d4d5',
                  borderRadius: '5px',
                  padding: '10px',
                  width: '100%',
                }}
              >
                <Header style={{ textTransform: 'uppercase' }}>
                  {searchedAnagrafica.nominativo}
                  <Header.Subheader>Codice fiscale: {searchedAnagrafica.codicefiscale}</Header.Subheader>
                </Header>
              </div>
              <Button
                onClick={() => this.onAggiungiGarante()}
                type="button"
                icon="save"
                labelPosition="right"
                positive
                content="Aggiungi garante"
                loading={isCreatingImpresa}
                disabled={isCreatingImpresa}
                style={{ width: '250px', marginTop: '8px' }}
              />
            </div>
          ) : null}
        </div>
      );
    }

    return (
      <div style={{ padding: '10px', marginBottom: '10px' }}>
        <Header>
          <Divider horizontal>GARANTE</Divider>
        </Header>
        {impresa && impresa.garante ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div
              style={{
                marginTop: '8px',
                border: '1px solid #d4d4d5',
                borderRadius: '5px',
                padding: '10px',
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Header
                style={{
                  marginBottom: 0,
                  textTransform: 'uppercase',
                }}
              >
                {impresa.garante.nominativo}
                <Header.Subheader>CODICE FISCALE: {impresa.garante.codicefiscale}</Header.Subheader>
              </Header>
              <BtnWithActions actions={this.getActions()} otherActions={[]} />
            </div>
          </div>
        ) : null}
        <FullModal
          hiddenHeader
          open={modalAnagraficaOpened}
          onClose={this.onCloseModalAnagrafica}
          title={
            <h2>
              <Icon name="id card" /> Modifica anagrafica
            </h2>
          }
          size="tiny"
        >
          {isLoadingAnagrafica ? (
            <div style={{ padding: '20px', textAlign: 'center' }}>Caricamento...</div>
          ) : (
            selectedAnagrafica &&
            selectedAnagrafica.id && (
              <AnagraficaForm
                ruolo="Anagrafica"
                validationType="anagrafica"
                onEdit={() => {}}
                update={() => {}}
                notifications={{ addNotification: notification().addNotification }}
                reconcile={() => {}}
                close={this.onCloseModalAnagrafica}
                initialValues={mapToInitialValues(selectedAnagrafica, provenienzeOptions)}
                cliente={mapToClienteInitialValues(selectedAnagrafica)}
                auth={this.props.auth}
              />
            )
          )}
        </FullModal>
      </div>
    );
  }
}

ImpresaGarante.propTypes = {
  /** Impresa data */
  impresa: PropTypes.object,
  /** Boolean if is a new impresa or existing one */
  isGarantePresente: PropTypes.bool,
  /** Function for call the notification system */
  notification: PropTypes.func,
  /** Object with data of logged user */
  auth: PropTypes.object,
  /** Function to refresh impresa data after anagrafica update */
  onRefresh: PropTypes.func,
};

export default ImpresaGarante;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaGarante/index.js